import { cn } from "~/lib/utils";

/* eslint-disable react/prop-types */
type VideoCardSkeletonProps = {
  type: "circle" | "square" | "rectangular" | "vertical";
};
const VideoCardSkeleton: React.FC<VideoCardSkeletonProps> = ({ type }) => {
  return (
    <div
      className={cn(
        `w-full flex flex-col gap-1 justify-center items-center cursor-pointer relative animate-pulse `,
        type === "circle" ? "rounded-full" : "rounded-xl"
      )}
    >
      {/* Thumbnail skeleton */}
      <div
        className={`w-full relative overflow-hidden z-10 bg-gray-200 ${
          type === "circle" ? "aspect-square rounded-full" : type === "vertical" ? "aspect-[2/3] rounded-xl" : "aspect-video rounded-xl"
        }`}
      />

      {/* Video Info Skeleton */}
      <div className="w-full flex flex-col justify-start items-start p-1 gap-2">
        {/* Title */}
        <div className="h-5 w-4/5 bg-gray-200 rounded" />

        {/* Meta info row */}
        <div className="w-full flex justify-start items-center gap-2 mt-1">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-4 w-14 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export default VideoCardSkeleton;
